module.exports = __webpack_public_path__ + "img/08.c1946984.png";